import { Form } from "@redriver/cinnamon-mui";
import { enquiryStatusLookup } from "modules/lookups";

const EnquiryStatusDropdown = (props) => (
  <Form.Dropdown {...props} lookup={enquiryStatusLookup} />
);

export default EnquiryStatusDropdown;
